import { createSlice } from "@reduxjs/toolkit";
import { STAUTES } from "../../../../utils/constant";
import { EMPLOYEES, IDENTITY_LOGIN } from "../../../../utils/services/apiPath";
import { getApi, postApi, refreshToken } from "../../../../utils/services";
import { expiredSessionHelper, loginHelper, logoutHelper } from "../../../../utils/helper";

const initialState = {
  isAuthenticated: false,
  isMounted: false,
  user: null,
  status: STAUTES.IDLE
};

const getEmployeeProfilePicture = employee => {
  if (typeof employee?.profileMediaModel === "string") return employee.profileMediaModel;
  return employee?.profileMediaModel?.path || employee?.profilePicture;
};

const updateStoredUser = user => {
  localStorage.setItem("user", JSON.stringify(user));
};

export const handleIdentityLogin = (payload, callback) => {
  return async dispatch => {
    dispatch(SET_STATUS(STAUTES.LOADING));
    try {
      const data = await postApi(IDENTITY_LOGIN, { ...payload });
      const authUser = loginHelper(data);
      dispatch(LOGIN(authUser));

      const employee = authUser.employeeId ? await getApi(`${EMPLOYEES}/${authUser.employeeId}?portalType=3`) : null;
      const clientUserProfilePicture = getEmployeeProfilePicture(employee);

      if (clientUserProfilePicture) {
        const updatedUser = { ...authUser, clientUserProfilePicture };
        updateStoredUser(updatedUser);
        dispatch(UPDATE_USER(updatedUser));
      }

      dispatch(SET_STATUS(STAUTES.IDLE));
    } catch (error) {
      console.log(error);
      callback(error.message);
      dispatch(SET_STATUS(STAUTES.ERROR));
    }
  };
};

export const handleLogout = () => {
  return async dispatch => {
    dispatch(SET_STATUS(STAUTES.LOADING));
    try {
      logoutHelper();
      dispatch(LOGOUT());
      dispatch(SET_STATUS(STAUTES.IDLE));
    } catch (error) {
      dispatch(SET_STATUS(STAUTES.ERROR));
    }
  };
};

export const handleInitialize = () => {
  return async dispatch => {
    try {
      if (await refreshToken()) {
        const user = JSON.parse(localStorage.getItem("user"));
        if (user) {
          dispatch(LOGIN(user));
        }
        dispatch(SET_MOUNTED());
      } else {
        expiredSessionHelper();
      }
    } catch (error) {
      console.log(error);
      dispatch(SET_MOUNTED());
    }
  };
};

export const handleUpdateUser = payload => {
  return async (dispatch, getState) => {
    const currentUser = getState().auth.user;
    const definedPayload = Object.fromEntries(Object.entries(payload).filter(([, value]) => value !== undefined));
    const updatedUser = { ...currentUser, ...definedPayload };

    updateStoredUser(updatedUser);
    dispatch(UPDATE_USER(updatedUser));
  };
};

const authSlice = createSlice({
  name: "auth",
  initialState,
  reducers: {
    LOGIN: (state, action) => {
      state.isAuthenticated = true;
      state.user = action.payload;
    },
    LOGOUT: state => {
      state.isAuthenticated = false;
      state.user = null;
    },
    UPDATE_USER: (state, action) => {
      state.user = action.payload;
    },
    SET_STATUS: (state, action) => {
      state.status = action.payload;
    },
    SET_MOUNTED: state => {
      state.isMounted = true;
    }
  }
});

export const { LOGIN, LOGOUT, UPDATE_USER, SET_STATUS, SET_MOUNTED } = authSlice.actions;

export const loginSelector = state => state.auth;

export default authSlice.reducer;
